module.exports = __webpack_public_path__ + "img/icon2.6b301968.png";